import { Component, OnInit } from '@angular/core';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { Subject } from 'rxjs';
import { uri } from '@bo-client/shared/constants/uri';
import { AnswerWithMoreInfoModel } from '@bo-client/activation-management/shared/models/AnswerWithMoreInfoModel';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-order-request-confirmation',
  templateUrl: './order-request-confirmation.component.html',
  styleUrls: ['./order-request-confirmation.component.scss']
})
export class OrderRequestConfirmationComponent extends ConfirmationRequestPageBase<any> implements OnInit {
  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog
  ) {
    super(route, router, httpService, toastService, matDialog);
  }

  compUnsubs$: Subject<void> = new Subject<void>();
  requestApprovalDto: RequestApprovalDto;
  uriGetData: string = uri.hapApproveOrderRequestExternal;

  ngOnInit() {
    super.init();
  }

  hookDataLoaded(answer: AnswerWithMoreInfoModel) {
    this.navigateTo(answer);
  }

  hookGetDataFromForm() {}

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
